'use client'

import Loading from '@/components/widgets/Loading'
import { useUser } from '@/components/widgets/UserProvider'
import { useRouter } from 'next/navigation'
import React from 'react'

type UpperHeadingProp = {
  spanText?: string
  title: string
  minSize?: string
  position?: string
  reverse?: boolean
  isHovered?: boolean
  isOpenPage?: string
}
const UpperHeading = ({
  title,
  spanText,
  minSize,
  position,
  reverse,
  isHovered = false,
  isOpenPage = undefined,
}: UpperHeadingProp) => {
  const router = useRouter()
  const { userPageLoading } = useUser()

  let fontSize = '28px'
  let place = ''
  if (minSize != null) {
    fontSize = `${minSize}px`
  }
  switch (position) {
    case 'start':
      place = 'start'
      break
    case 'center':
      place = 'center'
      break
    case 'end':
      place = 'end'
      break
    default:
      place = 'center'
      break
  }
  return (
    <>
      {userPageLoading ? (
        <Loading
          classes={
            'flex-grow flex relative max-h-screen sm:min-h-[45px] mx-[20%] bg-[rgba(128,128,128,0.3)] !text-white'
          }
        />
      ) : (
        <h1
          onClick={() => isOpenPage !== undefined && router.push(isOpenPage)}
          className={`font-barlowSemibold tracking-[2.5px] cursor-${
            isOpenPage ? 'pointer' : 'default'
          }
    text-${place} text-[${fontSize}]
    decoration-[1px] underline-offset-4 transition-[text-decoration-color] duration-300 ${
      isHovered ? 'hover:underline' : ''
    }
    group-hover:underline hover:decoration-current`}
        >
          {reverse ? (
            <>
              <span className=' font-barlowSemibold'>{title}</span>{' '}
              <span className=' font-barlowLight'>{spanText}</span>
            </>
          ) : (
            <>
              <span className=' font-barlowLight'>{spanText}</span>{' '}
              <span className=' font-barlowSemibold'>{title}</span>
            </>
          )}
        </h1>
      )}
    </>
  )
}

export default UpperHeading
// text-${place} text-[${fontSize}] switch:text-[16px] md:text-[20px] lg:text-[24px]
